// extracted by mini-css-extract-plugin
export var copyableField = "_s0-4";
export var customerBadge = "_s0-0";
export var customerInfoTitle = "_s0-2";
export var details = "_s0-1";
export var dropdownContainer = "_s0-5";
export var dropdownImage = "_s0-6";
export var editAssigneeForm = "_s0-a";
export var editButton = "_s0-3";
export var email = "_s0-7";
export var hidden = "_s0-d";
export var input = "_s0-8";
export var saveButton = "_s0-b";
export var shopifyIcon = "_s0-c";
export var suggestionBadge = "_s0-e";
export var suggestionText = "_s0-f";
export var username = "_s0-9";